import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { AxiosError } from 'axios';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { useMutation, useQueryClient } from 'react-query';
import { CUSTOM_MODEL_QUERY_KEYS } from './query-keys';

export interface DeleteTranscriptPayload {
  modelId: number;
  datasetId: number;
}

async function deleteTranscript(
  payload: DeleteTranscriptPayload
): Promise<BaseResponse<unknown>> {
  const { modelId, datasetId } = payload;
  const url = `${DELETE_URL(modelId.toString()).deleteCustomModelTranscript}${datasetId}`;
  const { data } = await Axios.delete(url);
  return data;
}

export function useDeleteTranscriptCustomModel() {
  const queryClient = useQueryClient();

  return useMutation<
    BaseResponse<unknown>,
    AxiosError<BaseError>,
    DeleteTranscriptPayload
  >(deleteTranscript, {
    onSuccess: (_data, { modelId }) => {
      // Invalidate model data queries to refresh the dataset list
      queryClient.invalidateQueries(CUSTOM_MODEL_QUERY_KEYS.data(modelId));
      // Invalidate model details as dataset count may have changed
      queryClient.invalidateQueries(CUSTOM_MODEL_QUERY_KEYS.detail(modelId));
    },
    useErrorBoundary: false
  });
}
